import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import Details from "./partials/details/Details";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";
import {
  detailsInitialState,
  detailsReducer,
} from "../../../reducers/module/detailsReducer";
import { Button } from "react-bootstrap";
import useConfirm from "../../../HOC/custom/useConfirm";
import SubscriptionStatusModal from "./partials/details/SubscriptionStatusModal";

const SubscriptionView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    detailsInitialState,
  );
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [status, setStatus] = useState(0);
  let { id } = useParams();
  const { confirm } = useConfirm();
  const loadItem = async () => {
    await loadItemGeneral(id, `${moduleConfig.url}/${id}`, detailsDispatch);
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.details,
    ]);
  }, [id]);
  const confirmAndAction = async (id, status) => {
    //console.log(status, status === "1" || status === 1 ? "complete" : "cancel");
    const isConfirmed = await confirm(
      `Do you really want to return the deposit?`,
    );

    if (isConfirmed) {
      setShowStatusModal(true);
    }
  };
  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>
                  {detailsState.data.item.depositReturned != "1" && (
                    <div className="border mb-1 p-1 bg-light text-white rounded">
                      <Button
                        className="btn-custom-2 me-1 "
                        variant="danger"
                        title={`Cancel order`}
                        onClick={() =>
                          confirmAndAction(detailsState.data.item._id)
                        }
                      >
                        <i className="fas fa-times me-1"> </i>{" "}
                        <span className="">Return Deposit</span>
                      </Button>
                    </div>
                  )}
                  <Details
                    item={detailsState.data.item}
                    moduleConfig={moduleConfig}
                  />
                  <SubscriptionStatusModal
                    show={showStatusModal}
                    setShow={setShowStatusModal}
                    loadItem={loadItem}
                    id={detailsState.data.item._id}
                    item={detailsState.data.item}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default SubscriptionView;
